import React, { useState, useEffect, useRef } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Slider from '@material-ui/core/Slider';
import Fab from '@material-ui/core/Fab';
import PlayIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import SpeakerIcon from '@material-ui/icons/VolumeUp';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import BackIcon from '@material-ui/icons/KeyboardBackspace';
import CheckedIcon from '@material-ui/icons/CheckCircle';
import NotCheckedIcon from '@material-ui/icons/HighlightOff';
import Button from '@material-ui/core/Button';
import { img, staticsUrl } from '../../config';

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    width: 'calc(100% - 4px)',
    marginLeft: 2,
    height: 6,
  },
  rail: {
    height: 6,
    backgroundColor: '#7c8ad6',
  },
  track: {
    height: 6,
    borderRadius: 0,
    backgroundColor: '#7c8ad6',
  },
  thumb: {
    backgroundColor: '#fff',
    marginTop: -3,
  },
})(Slider);

const useStyles = makeStyles(theme => ({
  say: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
  },
  menu: {
    maxWidth: '100%',
    minHeight: 450,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& > div': {
      border: '3px solid #C3CCE9',
      width: 400,
      maxWidth: '100%',
      textAlign: 'center',
      cursor: 'pointer',
      borderRadius: 5,
      marginBottom: 5,
      padding: 5,
      background: '#fff',
      '&:hover': {
        background: '#EFF3FA',
      },
    },
    '& img': {
      maxWidth: 400,
      marginBottom: 20,
    },
  },
  quiz: {
    width: 700,
    maxWidth: '100%',
    minHeight: 450,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  player: {
    background: '#3f51b5',
    borderRadius: 4,
    width: '100%',
    padding: 4,
    display: 'flex',
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > button': {
      marginRight: 5,
      borderRadius: 6,
    },
  },
  display: {
    width: '100%',
    padding: '9px 5px 0',
  },
  time: {
    fontSize: '0.9em',
    padding: '6px 5px 0',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    opacity: 0.75,
    lineHeight: 1.1,
    letterSpacing: 1,
    marginRight: 5,
  },
  text: {
    '& > span': {
      margin: '0 2px',
    }
  },
  words: {
    textAlign: 'center',
    margin: '0.5em 0',
    '& > span': {
      display: 'inline-block',
      padding: '0.1em 0.5em',
      margin: '0.25em',
      background: '#f1f3ff',
      color: theme.palette.primary.main,
      cursor: 'grab',
      borderRadius: 4,
      fontWeight: 500,
      '&:active': {
        cursor: 'grabbing',
        color: theme.palette.secondary.main,
      },
      '&.active': {
        color: theme.palette.secondary.main,
      },
      '&.hidden': {
        display: 'none',
      },
    },
  },
  quizAction: {
    textAlign: 'center',
    marginTop: 20,
    '& > button': {
      margin: '0 5px',
    },
    '& span': {
      userSelect: 'none',
    },
  },
  gap: {
    fontWeight: 600,
    background: '#e7ebff',
    boxSizing: 'border-box',
    border: '1px solid #fff',
    width: 60,
    display: 'inline-block',
    textAlign: 'center',
  },
  done: {
    color: '#1d9021',
    marginRight: 5,
    float: 'right',
  },
  notDone: {
    color: '#ccc',
    marginRight: 5,
    float: 'right',
  },
  repeat: {
    cursor: 'pointer',
    verticalAlign: 'middle',
    paddingTop: 20,
    '& svg': {
      marginRight: 10,
      verticalAlign: 'middle',
      color: '#999',
    },
    '& p': {
      margin: 0,
      padding: '0.25em 0.5em',
      userSelect: 'none',
      '&:hover': {
        background: '#eee',
      },
      '&:active': {
        '& svg': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  img: {
    textAlign: 'center',
    '& img': {
      maxWidth: '100%',
    },
  },
  sayText: {
    textAlign: 'center',
  },
  angText: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  '@media(max-width: 850px)': {
    say: {
      '& > div': {
        padding: '0 10px 20px',
      },
    },
  }
}));

let wordNo = false;

function Say(props) {
  const classes = useStyles();
  const [ mediaStatus, setMediaStatus ] = useState('paused');
  const [ state, setState ] = useState('menu');
  const [ no, setNo ] = useState(0);
  const [ complete, setComplete ] = useState([ false, false, false ]);
  const [ time, setTime ] = useState(0);
  const [ timeText, setTimeText ] = useState('0:00');
  const [ words, setWords ] = useState([]);
  const [ availWords, setAvailWords ] = useState([]);
  const [ gaps, setGaps ] = useState([]);
  const [ showTrans, setShowTrans ] = useState(false);
  const { exercise, expand, startStats, finishExercise, action, type } = props.exerciseProps;
  const len = exercise.sentences.length; // exercise length
  const refs = [];
  const repeatPresent = exercise.repetition.length > 0;
  const sayItPresent = exercise.sentences.length > 0;

  let gapNo = -1;
  // eslint-disable-next-line
  for (let i = 0; i < 30; i++) refs[i] = useRef(null);

  useEffect(() => {
    startStats(type);
    const { playing, pause, waiting, timeupdate } = props.media.events;
    const playSubscribtion = playing.subscribe((ev) => setMediaStatus('playing'));
    const pauseSubscribtion = pause.subscribe((ev) => setMediaStatus('paused'));
    const waitingSubscribtion = waiting.subscribe((ev) => setMediaStatus('waiting'));
    const timeSubscribtion = timeupdate.subscribe(updateTime);

    return () => {
      playSubscribtion.unsubscribe();
      pauseSubscribtion.unsubscribe();
      waitingSubscribtion.unsubscribe();
      timeSubscribtion.unsubscribe();
      props.media.pause();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const gaps = [];
    const words = [];
    const availWords = [];
    let no = 0;
    exercise.gaps.forEach((el, idx) => {
      if (el.type === 'GAP') {
        gaps.push(el.text);
        words.push(false);
        availWords.push({ text: el.text, idx: no });
        no++;
      }
    });
    setGaps(gaps);
    setWords(words);
    setAvailWords(shuffle(availWords));
  }, [exercise]);

  const play = (url) => {
    action();
    const soundUrl = staticsUrl + (typeof url === 'string' ? url : exercise.sound.url);
    props.media.play(soundUrl);
  }

  const pause = () => {
    action();
    props.media.pause();
  }

  const next = () => {
    if (no < len - 1) setNo(no + 1);
    action();
    setShowTrans(false);
  }
  const prev = () => {
    if (no > 0) setNo(no - 1);
    action();
    setShowTrans(false);
  }

  const updateTime = () => {
    const timeStr = displayTime(props.media.getAudioTime());
    action();
    if (timeStr === timeText) return;
    setTimeText(timeStr);
    setTime(props.media.getAudioTime());
  }

  const changeTime = (ev, time) => {
    const time2 = parseFloat(time);
    if (time2 < props.media.getAudioDuration()) {
      setTime(time);
      props.media.setAudioTime(time2);
    }
  }

  const renderMenu = () => {
    return (
      <div  className={classes.menu}>
        {exercise.image && <img src={staticsUrl + exercise.image.url} alt='' />}
        <div onClick={() => setState('quiz')}>
          <span>Luki w tekście</span>
          {complete[0] && <CheckedIcon className={classes.done}/>}
          {!complete[0] && <NotCheckedIcon className={classes.notDone}/>}
        </div>
        {repeatPresent && <div onClick={() => setState('repeat')}>
          <span>Powtórzenie</span>
          {complete[1] && <CheckedIcon className={classes.done}/>}
          {!complete[1] && <NotCheckedIcon className={classes.notDone}/>}
        </div>}
        {sayItPresent && <div onClick={() => setState('say-it')}>
          <span>Powiedz to!</span>
          {complete[2] && <CheckedIcon className={classes.done}/>}
          {!complete[2] && <NotCheckedIcon className={classes.notDone}/>}
        </div>}
      </div>
    );
  }

  const renderPlayer = () => {
    return (
      <div className={classes.player}>
          <div className={classes.controls}>
            {mediaStatus === 'paused' && <Fab size="small" onClick={play}>
              <PlayIcon className={classes.largeIcon} color="primary"/>
            </Fab>}
            {mediaStatus === 'playing' && <Fab size="small" onClick={pause}>
              <PauseIcon className={classes.largeIcon} color="primary"/>
            </Fab>}
            {mediaStatus === 'waiting' && <Fab size="small" onClick={pause} disabled>
              <PauseIcon className={classes.largeIcon} color="primary"/>
            </Fab>}
          </div>
          <div className={classes.time}>
            <div>{timeText}</div>
            <div>{displayTime(props.media.getAudioDuration())}</div>
          </div>
          <div className={classes.display}>
            <PrettoSlider value={time} onChange={changeTime} max={props.media.getAudioDuration() || 100}/>
          </div>
        </div>
    );
  }

  const renderElement = (el, idx) => {
    if (el.type === 'GAP') {
      gapNo++;
      const gap = words[gapNo];
      return (
        <React.Fragment key={idx}>
          {!gap && <span
            className={classes.gap}
            onDragOver={ev => ev.preventDefault()}
            onDrop={drop(gapNo)}
            onClick={drop(gapNo)}
          >{gapNo + 1}</span>}
          {gap && <span style={{fontWeight: 600}}>{gap}</span>}
          {el.newLine && <br />}
        </React.Fragment>
      );
    }
    if (el.type === 'TEXT') {
      return (
        <React.Fragment key={idx}>
          <span dangerouslySetInnerHTML={{__html: el.text}} />
          {el.newLine && <br />}
        </React.Fragment>
      );
    }
  }

  const clearActive = () => {
    for (let i = 0; i < 30; i++) {
      refs[i] && refs[i].current && refs[i].current.classList.remove('active');
    }
  }

  const drag = no => {
    clearActive();
    action();
    refs[no].current.classList.add('active');
    wordNo = no;
  }

  const drop = no => () =>  {
    action();
    if (wordNo === false) return;
    clearActive();
    props.media.success();
    refs[wordNo].current.classList.add('hidden');
    const wordsCopy = [...words];
    wordsCopy[no] = availWords.find(word => word.idx === wordNo).text;
    setWords(wordsCopy);
    wordNo = false;
  }

  const renderWords = () => {
    return (
      <div className={classes.words}>
        {availWords.map(word => {
          const no = word.idx;
          return <span 
            key={no} 
            ref={refs[no]}
            draggable="true"
            onDragStart={() => drag(no)}
            onClick={() => drag(no)}
          >{word.text}</span>
        })}
      </div>
    );
  }

  const renderQuiz = () => {
    const goBack = () => {
      props.media.pause();
      setState('menu')
    }
    return (
      <div className={classes.quiz}>
        {renderPlayer()}
        {renderWords()}
        <div className={classes.text}>
          {exercise.gaps.map((el, idx) => renderElement(el, idx))}
        </div>
        <div className={classes.quizAction}>
          <Button variant="outlined" color="secondary"  onClick={goBack}>Powrót</Button>
          <Button variant="outlined" color="secondary" onClick={checkQuiz} >Sprawdź zadanie</Button>
        </div>
      </div>
    );
  }

  const checkQuiz = () => {
    let correct = true;
    const newWords = [];
    gaps.forEach((word, idx) => {
      if (word === words[idx]) {
        newWords.push(word);
      } else {
        correct = false;
        newWords.push(false);
        refs[idx].current.classList.remove('hidden');
      }
    });
    if (correct) {
      // test zdany
      props.media.finish();
      completePart(0);
    } else {
      // test niezdany
      setWords(newWords);
      props.media.failure();
    }
  }

  const renderRepeat = () => {
    completePart(1);
    const goBack = () => {
      setState('menu');
      pause();
    }
    return (
      <div className={classes.repeat}>
        {exercise.repetition.map((word, idx) => <p key={idx} onClick={() => play(word.soundUrl)}><SpeakerIcon /> {word.text}</p>)}
        <div className={classes.quizAction}>
          <Button variant="outlined" color="secondary"  onClick={goBack}>Powrót</Button>
        </div>
      </div>
    );
  }

  const renderSayIt = () => {
    const sentence = exercise.sentences[no];
    const goBack = () => {
      setState('menu');
      pause();
    }

    const sayIt = () => {
      play(sentence.soundUrl);
      setShowTrans(true);
      if (no === len - 1) completePart(2);
    }

    return (
      <div className={classes.sayIt}>
        <div className={classes.img}>
          <h3>Powiedz po angielsku</h3>
          {exercise.image && <img src={staticsUrl + exercise.image.url} alt='' />}
        </div>
        <div className={classes.sayText}>
          <p>{sentence.translation}</p>
          {showTrans && <p className={classes.angText}>{sentence.text}</p>}
        </div>
        <div className={classes.quizAction}>
          <Button variant="outlined" color="secondary"  onClick={goBack}><BackIcon /></Button>
          <Button variant="outlined" color="secondary" onClick={prev} disabled={no === 0}><PrevIcon /></Button>
          <span>{no + 1}/{len} </span>
          <Button variant="outlined" color="secondary" onClick={next} disabled={no === len - 1}><NextIcon /></Button>
          <Button variant="outlined" color="secondary" onClick={sayIt}><SpeakerIcon /></Button>
        </div>

      </div>
    );
  }

  const completePart = (no) => {
    if (complete[no]) return;
    const result = [ ...complete ];
    result[no] = true;
    setComplete(result);
    if (
      (complete[0] || no === 0) &&
      (complete[1] || !repeatPresent || no === 1) &&
      (complete[2] || !sayItPresent || no ===2)
    ) finishExercise();
  }

  return (
    <div className={classes.say}>
      <div>
        {expand && props.mobile && <div style={{height: 40}}>&nbsp;</div>}
        {state === 'menu' && renderMenu()}
        {state === 'quiz' && renderQuiz()}
        {state === 'repeat' && renderRepeat()}
        {state === 'say-it' && renderSayIt()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

function displayTime(time) {
  if(isNaN(time)) return '0:00';
  const minutes = Math.floor(time / 60);
  const seconds = ('0' + Math.floor(time - minutes * 60)).substr(-2);
  return `${minutes}:${seconds}`;
}

export default connect(mapStateToProps)(Say);